import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faDollarSign, faEdit, faHashtag, faPercentage, faPlus, faTimes, faAngleLeft, faTrashAlt,faFilter,faArrowRight,faAngleRight,faAngleDoubleRight,faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import { currencyFormat } from '../../js/Functions';
import Materiales from '../materiales/ListarTabla';
class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: [],
        capitulos: [],
        ListaMateriales: [],
        errores: [],
        ListaMP:[],
        TEQP:0,
        TTRA:0,
        TMO:0,
        TMAT:0,
        TOTAL:0
    }
    cambioValor = (e) => {
        const state = this.state.arrayResultado;
        state[e.target.name] = e.target.value;
        this.setState({ arrayResultado: state });

    };
    Calcular = () => {
        var valor_unitario = document.getElementById('valor_compra').value;
        var iva = document.getElementById('iva').value;
        var utilidad = document.getElementById('utilidad').value;
        var total1 = 0;
        var total2 = 0;
        var total = 0;
        if (valor_unitario != '' || valor_unitario != 0) {
            if (iva != '' || iva != 0) {
                total1 = valor_unitario * (iva / 100);
                console.log(total1);
            }
            if (utilidad != '' || utilidad != 0) {
                total2 = valor_unitario * (utilidad / 100);
                console.log(total2);
            }
            total = (parseFloat(total2) + parseFloat(total1)) + parseFloat(valor_unitario);
        }
        document.getElementById('valor_unitario').value = total;
        document.getElementById('valor_real').value = total;
        console.log(total);
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    
    enviarDatos = (e) => {
        e.preventDefault();
        const id_tipo_unidad = document.getElementById('ID_TIPO_UNIDAD').value;
        const capitulo = document.getElementById('ID_CAPITULO').value;
        const codigo = document.getElementById('codigo').value;
        const nombre = document.getElementById('nombre').value;
        const estado = document.getElementById('ESTADO').value;
        const administracion = document.getElementById('administracion').value;
        const utilidad = document.getElementById('utilidad').value;
        const imprevisto = document.getElementById('imprevisto').value;
        var errores = [];
        if (!id_tipo_unidad) { errores.push("error_id_tipo_unidad"); }
        if (!capitulo) { errores.push("error_id_capitulo"); }
        if (!codigo) { errores.push("error_codigo"); }
        if (!nombre) { errores.push("error_nombre"); }
        if (!estado) { errores.push("error_estado"); }
        if (!administracion) { errores.push("error_administracion"); }
        if (!utilidad) { errores.push("error_utilidad"); }
        if (!imprevisto) { errores.push("error_imprevisto"); }
        let form = document.getElementById('formulario');
        let formData = new FormData(form);
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        Swal.showLoading();
        authAxios.post("productos/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Producto!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/UpProductos/" + this.props.match.params.id);
            })
            .catch(console.log)
    }
    pasar(id) {
        console.log(id);
        document.getElementById('btipo').value = id;
        this.ListarArrayResultado(1);
    }
    datos(){
        Swal.showLoading();
        authAxios.get("productos/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ arrayResultado: datosRespuesta.data.Productos });
                this.ListaRelacion();
            })
            .catch(console.log);
        authAxios.get("capitulos/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({capitulos: datosRespuesta.data.lista.data});
                Swal.close();
            })
    }
    ListaRelacion(){
        authAxios.get("productos/vermp/" + this.props.match.params.id)
        .then((datosRespuesta) => {
            console.log(datosRespuesta);
            this.setState({ datosCargados: true, ListaMateriales: datosRespuesta.data.Materiales, load: '',TEQP:datosRespuesta.data.t_eqp,TMAT:datosRespuesta.data.t_mat,TMO:datosRespuesta.data.t_mo,TTRA:datosRespuesta.data.t_tra,TOTAL:datosRespuesta.data.total });
        })
        .catch(console.log);
    }
    ListarArrayResultado(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        let btipo = document.getElementById('btipo').value;
        let bmuni = document.getElementById('bmunicipio').value;
        let global = document.getElementById('global').value;
        var datos = {tipo:btipo, nombre:bname,municipio:bmuni,globla:global};
        authAxios.post("materiales/index_new?page=" + page, datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', ListaMP: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
                Swal.close();
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    PasarMp(id) {
        Swal.showLoading();
        let cantidad = document.getElementById('cantidadProducto_'+id).value;
        var usuario = window.localStorage.getItem('idusuario');
        var tipo =document.getElementById('btipo').value;
        var rendimiento = document.getElementById('rendimiento_'+id).value;
        

         var datosEnviar = {
            tipo_mp: tipo,
            codigo_mp: id,
            apu: this.props.match.params.id,
            cantidad: cantidad,
            rendimiento: rendimiento,
            usuario:usuario
        }
        Swal.showLoading();
        authAxios.post("productos/registrar_material", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Materiales!',
                        datosRespuesta.data.msj,
                        'success'
                    );
                    this.ListaRelacion();
                } else {
                    Swal.close();
                    Swal.fire(
                        'Materiales!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log) 

        
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Registro?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("productos/borrar_material/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListaRelacion();
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    componentDidMount() {
       this.datos();
       
    }
    render() {
        const { load, arrayResultado, ListaMateriales, capitulos, pagina, ultimo, actual,ListaMP,TEQP,TTRA,TMO,TMAT,TOTAL } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>DETALLE DE PRODUCTO {arrayResultado.NOMBRE}</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="formulario">
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-4">
                                                    <label htmlFor="ID_CAPITULO">Categoría</label>
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <div className="input-group input-group-sm">
                                                        <select name="ID_CAPITULO"
                                                            id="ID_CAPITULO"
                                                            value={arrayResultado.ID_CAPITULO}
                                                            options={arrayResultado.ID_CAPITULO}
                                                            className={((this.verificarError("error_id_capitulo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.cambioValor}>
                                                            <option value="">Seleccione la Categoría</option>
                                                            {
                                                                capitulos.map((itemCapitulos) => (
                                                                    <option key={itemCapitulos.ID_TABLA} value={itemCapitulos.ID_TABLA}>{itemCapitulos.ID_CAPITULO} - {itemCapitulos.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Categoría</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="codigo">Código</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="codigo" id="codigo" defaultValue={arrayResultado.CODIGO}
                                                            className={((this.verificarError("error_codigo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Código" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Código</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="ID_TIPO_UNIDAD">Unidad</label>
                                                    <select name="ID_TIPO_UNIDAD"
                                                        id="ID_TIPO_UNIDAD"
                                                        value={arrayResultado.ID_TIPO_UNIDAD}
                                                        options={arrayResultado.ID_TIPO_UNIDAD}
                                                        className={((this.verificarError("error_id_tipo_unidad")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Unidad</option>
                                                        <option value="1">Global (GLB)</option>
                                                        <option value="2">Metros (M)</option>
                                                        <option value="3">Rollo</option>
                                                        <option value="4">Unidad (UND)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Unidad</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="ESTADO">Estado</label>
                                                    <select name="ESTADO"
                                                        id="ESTADO"
                                                        value={arrayResultado.ESTADO}
                                                        options={arrayResultado.ESTADO}
                                                        className={((this.verificarError("error_estado")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="1">Activo</option>
                                                        <option value="0">Inactivo</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Descripción</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} id="nombre" name="nombre" rows='3'
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + ' form-control form-control-sm'}
                                                        onChange={this.cambioValor} aria-describedby="helpId" defaultValue={arrayResultado.PRODUCTO}>
                                                    </textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN PORCENTAJES</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="administracion">Administracion</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="administracion" id="administracion" defaultValue={arrayResultado.ADMINISTRACION}
                                                            className={((this.verificarError("error_administracion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Administración" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite la Administración</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="utilidad">Utilidad</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="utilidad" id="utilidad" defaultValue={arrayResultado.UTILIDAD}
                                                            className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Utilidad" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite la Utilidad</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="imprevisto">Imprevisto</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="imprevisto" id="imprevisto" defaultValue={arrayResultado.IMPREVISTO}
                                                            className={((this.verificarError("error_imprevisto")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Imprevisto" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Imprevisto</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="imprevisto">COSTO TOTAL</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="costo" id="costo" value={TOTAL}
                                                            className={" form-control form-control-sm"} placeholder="Costo" aria-describedby="helpId"
                                                            
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Imprevisto</small>
                                                    </div>
                                                </div>
                                                {/*<div className="col-md-2">
                                                    <label htmlFor="utilidad">Fecha Registro</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendar} /></span>
                                                        <input disabled style={{ textTransform: 'uppercase' }} type="text" name="utilidad" id="utilidad" defaultValue={arrayResultado.FECHA_REGISTRO}
                                                            className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Utilidad" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la utilidad</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_unitario">Ultima Actualizacion</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendar} /></span>
                                                        <input disabled style={{ textTransform: 'uppercase' }} type="text" name="valor_unitario" id="valor_unitario" defaultValue={arrayResultado.FECHA_ULT_ACT}
                                                            className={((this.verificarError("error_valor_unitario")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Unitario" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Unitario</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_real">Ultimo Usuario </label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faUser} /></span>
                                                        <input disabled style={{ textTransform: 'uppercase' }} type="text" name="valor_real" id="valor_real" defaultValue={arrayResultado.ULT_USUARIO}
                                                            className={((this.verificarError("error_valor_real")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Real" aria-describedby="helpId"
                                                            onChange={this.Calcular}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Real</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo">Costo calculado </label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input disabled style={{ textTransform: 'uppercase' }} type="text" name="costo" id="costo" defaultValue={arrayResultado.COSTO}
                                                            className={((this.verificarError("error_costo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Real" aria-describedby="helpId"
                                                            onChange={this.Calcular}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Real</small>
                                                </div>*/}
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Producto</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterProductos"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>I. EQUIPO </b>)}
                            </div>
                            <div className="card-body">
                                <form >
                                    <div className='row'>
                                        <div className='col-xl-12 text-left'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#ModalMP" onClick={() => this.pasar('EQP')}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Agregar Equipo</button>&nbsp;&nbsp;
                                               
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CÓDIGO</th>
                                                    <th className="align-middle">DESCRIPCIÓN</th>
                                                    <th className="align-middle">UNIDAD</th>
                                                    <th className="align-middle">CANTIDAD</th>
                                                    <th className="align-middle">RENDIMIENTO</th>
                                                    <th className="align-middle">VALOR UNIDAD</th>
                                                    <th className="align-middle">VALOR PARCIAL</th>
                                                    <th className="align-middle">OPCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {load}
                                                {
                                                    ListaMateriales.map((itemArrayResultado) => (
                                                        itemArrayResultado.TIPO_MP=='EQP'?
                                                        <tr key={itemArrayResultado.ID_RELACION}>
                                                            <td>{itemArrayResultado.CODIGO_MP}</td>
                                                            <td>{itemArrayResultado.NOMBRE}</td>
                                                            <td>{itemArrayResultado.TIPO_MP}</td>
                                                            <td>{itemArrayResultado.CANTIDAD_MP}</td>
                                                            <td>{(itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>{currencyFormat(itemArrayResultado.VALOR_REAL)}</td>
                                                            <td>{currencyFormat(((itemArrayResultado.VALOR_REAL * itemArrayResultado.CANTIDAD_MP)) * itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() =>
                                                                            this.borrarRegistros(itemArrayResultado.ID_RELACION)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>:''
                                                    ))
                                                }
                                            </tbody>
                                            <tr>
                                                <td colSpan="5"></td>
                                                <td>Total Equipo</td>
                                                <td>$ {currencyFormat(TEQP)}</td>
                                                <td>-</td>
                                            </tr>
                                        </table>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>II. SUMINISTRO Y/O MATERIALES </b>)}
                            </div>
                            <div className="card-body">
                                <form >
                                    <div className='row'>
                                        <div className='col-xl-12 text-left'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#ModalMP" onClick={() => this.pasar('MAT')}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Agregar Material</button>&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CÓDIGO</th>
                                                    <th className="align-middle">DESCRIPCIÓN</th>
                                                    <th className="align-middle">UNIDAD</th>
                                                    <th className="align-middle">CANTIDAD</th>
                                                    <th className="align-middle">RENDIMIENTO</th>
                                                    <th className="align-middle">VALOR UNIDAD</th>
                                                    <th className="align-middle">VALOR PARCIAL</th>
                                                    <th className="align-middle">OPCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {load}
                                                {
                                                    ListaMateriales.map((itemArrayResultado) => (
                                                        itemArrayResultado.TIPO_MP=='MAT'?
                                                        <tr key={itemArrayResultado.ID_RELACION}>
                                                            <td>{itemArrayResultado.CODIGO_MP}</td>
                                                            <td>{itemArrayResultado.NOMBRE}</td>
                                                            <td>{itemArrayResultado.TIPO_MP}</td>
                                                            <td>{itemArrayResultado.CANTIDAD_MP}</td>
                                                            <td>{(itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>{currencyFormat(itemArrayResultado.VALOR_REAL)}</td>
                                                            <td>{currencyFormat(((itemArrayResultado.VALOR_REAL * itemArrayResultado.CANTIDAD_MP)) * itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                   
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() =>
                                                                            this.borrarRegistros(itemArrayResultado.ID_RELACION)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        :''
                                                    ))
                                                }
                                            </tbody>
                                            <tr>
                                                <td colSpan="5"></td>
                                                <td>Total Material</td>
                                                <td>$ {currencyFormat(TMAT)}</td>
                                                <td>-</td>
                                            </tr>
                                        </table>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>III. TRANSPORTES </b>)}
                            </div>
                            <div className="card-body">
                                <form >
                                    <div className='row'>
                                        <div className='col-xl-12 text-left'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#ModalMP" onClick={() => this.pasar('TRA')}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Agregar Transporte</button>&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CÓDIGO</th>
                                                    <th className="align-middle">DESCRIPCIÓN</th>
                                                    <th className="align-middle">UNIDAD</th>
                                                    <th className="align-middle">CANTIDAD</th>
                                                    <th className="align-middle">RENDIMIENTO</th>
                                                    <th className="align-middle">VALOR UNIDAD</th>
                                                    <th className="align-middle">VALOR PARCIAL</th>
                                                    <th className="align-middle">OPCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {load}
                                                {
                                                    ListaMateriales.map((itemArrayResultado) => (
                                                        itemArrayResultado.TIPO_MP=='TRA'?
                                                        <tr key={itemArrayResultado.ID_RELACION}>
                                                            <td>{itemArrayResultado.CODIGO_MP}</td>
                                                            <td>{itemArrayResultado.NOMBRE}</td>
                                                            <td>{itemArrayResultado.TIPO_MP}</td>
                                                            <td>{itemArrayResultado.CANTIDAD_MP}</td>
                                                            <td>{(itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>{currencyFormat(itemArrayResultado.VALOR_REAL)}</td>
                                                            <td>{currencyFormat(((itemArrayResultado.VALOR_REAL * itemArrayResultado.CANTIDAD_MP)) * itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                   
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() =>
                                                                            this.borrarRegistros(itemArrayResultado.ID_RELACION)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        :''
                                                    ))
                                                }
                                            </tbody>
                                            <tr>
                                                <td colSpan="5"></td>
                                                <td>Total Transporte</td>
                                                <td>$ {currencyFormat(TTRA)}</td>
                                                <td>-</td>
                                            </tr>
                                        </table>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>IV. MANO DE OBRA </b>)}
                            </div>
                            <div className="card-body">
                                <form >
                                    <div className='row'>
                                        <div className='col-xl-12 text-left'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#ModalMP" onClick={() => this.pasar('MO')}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Agregar MO</button>&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CÓDIGO</th>
                                                    <th className="align-middle">DESCRIPCIÓN</th>
                                                    <th className="align-middle">UNIDAD</th>
                                                    <th className="align-middle">CANTIDAD</th>
                                                    <th className="align-middle">RENDIMIENTO</th>
                                                    <th className="align-middle">VALOR UNIDAD</th>
                                                    <th className="align-middle">VALOR PARCIAL</th>
                                                    <th className="align-middle">OPCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {load}
                                                {
                                                    ListaMateriales.map((itemArrayResultado) => (
                                                        itemArrayResultado.TIPO_MP=='MO'?
                                                        <tr key={itemArrayResultado.ID_RELACION}>
                                                            <td>{itemArrayResultado.CODIGO_MP}</td>
                                                            <td>{itemArrayResultado.NOMBRE}</td>
                                                            <td>{itemArrayResultado.TIPO_MP}</td>
                                                            <td>{itemArrayResultado.CANTIDAD_MP}</td>
                                                            <td>{(itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>{currencyFormat(itemArrayResultado.VALOR_REAL)}</td>
                                                            <td>{currencyFormat(((itemArrayResultado.VALOR_REAL * itemArrayResultado.CANTIDAD_MP)) * itemArrayResultado.RENDIMIENTO)}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() =>
                                                                            this.borrarRegistros(itemArrayResultado.ID_RELACION)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        :''
                                                    ))
                                                }
                                            </tbody>
                                            <tr>
                                                <td colSpan="5"></td>
                                                <td>Total Mano Obra</td>
                                                <td>$ {currencyFormat(TMO)}</td>
                                                <td>-</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5"></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5"></td>
                                                <td>TOTAL COSTO</td>
                                                <td className="bg-success">$ {currencyFormat(TOTAL)}</td>
                                                <td>-</td>
                                            </tr>
                                        </table>

                                        

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="ModalMP" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="UCAPModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="UCAPModalLabel">Registro de Materia Prima</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div>
                                    <div className="row">
                                    <div className='col-xl-12'>
                                    <div className="card">
                        
                        <div className="card-body">
                            
                            <div className="row">
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="Material" className="form-control form-control-sm" />
                                    
                                </div>
                                <div className="col-xl-2">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="btipo" name="btipo" placeholder="Material" className="form-control form-control-sm" />
                                    
                                </div>
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bmunicipio" name="bmunicipio" placeholder="Municipio" className="form-control form-control-sm" />
                                    
                                </div>
                                <div className="col-xl-2">
                                <select  className="form-select form-select-sm" name="global" id="global">
                                    <option value="0">Material Global</option>
                                    <option value="1">Material Historico</option>
                                </select>
                                </div>
                                <div className="col-xl-2">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                        <th className="align-middle">COD</th>
                                        <th className="align-middle">TIPO</th>
                                            <th className="align-middle">COD. SIESA</th>
                                            <th className="align-middle">MATERIAL</th>
                                            <th className="align-middle">UNIDAD</th>
                                            <th className="align-middle">VALOR COMPRA</th>
                                            <th className="align-middle">VALOR UNITARIO</th>
                                            <th className="align-middle">RENDIMIENTO</th>
                                            <th className="align-middle">CANT</th>
            
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            ListaMP.map((itemArrayResultado) => (
                                                <tr key={itemArrayResultado.ID_TABLA}>
                                                    <td>{itemArrayResultado.CODIGO}</td>
                                                    <td>{itemArrayResultado.TIPO}</td>
                                                    <td>{itemArrayResultado.COD_SIESA}</td>
                                                    <td>{itemArrayResultado.NOMBRE}<br></br>{itemArrayResultado.ULT_ACTUALIZACION}</td>
                                                    {
                                                        (() => {
                                                            switch (itemArrayResultado.ID_TIPO_UNIDAD) {
                                                                case 1:
                                                                    return (<td>GLB</td>)
                                                                case 2:
                                                                    return (<td>M</td>)
                                                                case 3:
                                                                    return (<td>ROLLO</td>)
                                                                case 4:
                                                                    return (<td>UND</td>)
                                                            }
                                                        })()
                                                    }
                                                     <td><b>$ </b>{currencyFormat(itemArrayResultado.VALOR_COMPRA)}</td>
                                                    <td><b>$ </b>{currencyFormat(itemArrayResultado.VALOR_UNITARIO)}</td>
                                                    <td>
                                                    <input className={"form-control form-control-sm"}
                                                                        type="text" id={'rendimiento_' + itemArrayResultado.ID_TABLA}
                                                                        name={'rendimiento_' + itemArrayResultado.ID_TABLA}
                                                                        aria-describedby="helpId" defaultValue={1}/>
                                                    </td>
                                                    <td>
                                                    <input className={"form-control form-control-sm"}
                                                                        type="text" id={'cantidadProducto_' + itemArrayResultado.ID_TABLA}
                                                                        name={'cantidadProducto_' + itemArrayResultado.ID_TABLA}
                                                                        disabled={itemArrayResultado.nueva_fecha>itemArrayResultado.fecha_actual? itemArrayResultado.VALOR_UNITARIO!=0?'':'':''}
                                                                        aria-describedby="helpId" />
                                                    </td>
                                             
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() =>
                                                                    this.PasarMp(itemArrayResultado.ID_TABLA)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faArrowRight} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                                    </div>
                                    </div>
                                    <hr />
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Editar;